module.exports = __webpack_public_path__ + "static/media/SF-7-A (1).0d6fa304.mp3";